import React from 'react';
import ProductListHeader from './Header';
import ProductList from './ProductList';

type BuyerListViewCategoryProps = {
  category: string;
  subCategory?: string;
};

const BuyerListViewCategory: React.FC<BuyerListViewCategoryProps> = ({
  category,
  subCategory,
}) => {
  return (
    <div className="mb-6">
      <ProductListHeader category={category} subCategory={subCategory} />
      <ProductList category={category} subCategory={subCategory} />
    </div>
  );
};

export default BuyerListViewCategory;
